/*
  İNZA ürün ve sepet sayfası yardımcıları.
  Ürün seçenekleri uygulamasının (yüzük ölçüsü ve hediye kolye ismi) alanlarına dokunmadan,
  üzerlerine küçük iyileştirmeler ekler:
  1. Yüzük ölçüsü boş başlar ("Ölçü seçin"), seçilmeden sepete eklenmez.
  2. İsim alanının altına ne işe yaradığını anlatan açıklama gelir.
  3. Uygulamanın 64,990.00TL biçiminde yeniden yazdığı fiyat Türkçe yazıma (64.990 TL) çevrilir.
  4. Ürün açıklamasının içinde ve sonunda kalan boş satırlar gizlenir.
  5. Mobilde sohbet balonu, fiyat satırlarının üstünü kapatacağı anda kenara çekilir.
  Uygulama alanları geç yüklediği için sayfa izlenir. Hata olursa sessizce devre dışı kalır.
*/
(function () {
  'use strict';

  // ---------- Sohbet balonu fiyatların üstünü kapatmasın (mobil) ----------
  var chatObserver = null;
  var chatHits = [];

  function watchChat() {
    try {
      if (!('IntersectionObserver' in window) || !window.matchMedia('(max-width: 699px)').matches) return;

      if (chatObserver) chatObserver.disconnect();
      chatHits = [];

      // Yalnızca ekranın alt şeridi (balonun durduğu bölge) dikkate alınır.
      chatObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var at = chatHits.indexOf(entries[i].target);
          if (entries[i].isIntersecting && at === -1) chatHits.push(entries[i].target);
          if (!entries[i].isIntersecting && at > -1) chatHits.splice(at, 1);
        }
        document.documentElement.classList.toggle('inza-chat-aside', chatHits.length > 0);
      }, { rootMargin: '-76% 0px 0px 0px' });

      var targets = document.querySelectorAll('.inza-pay, .inza-cart__rows, .inza-cart__pay');
      for (var j = 0; j < targets.length; j++) {
        targets[j].setAttribute('data-inza-watched', '');
        chatObserver.observe(targets[j]);
      }
    } catch (e) {}
  }

  watchChat();

  // ---------- Ürün açıklamasındaki boş satırlar ----------
  var MEDIA = 'img, picture, video, iframe, svg, table, hr, input, button, model-viewer, object, embed';

  function isBlank(el) {
    if (el.matches(MEDIA) || el.querySelector(MEDIA)) return false;
    return el.textContent.replace(/ /g, ' ').trim() === '';
  }

  function trimTail(node, depth) {
    var child = node.lastChild;
    while (child) {
      var prev = child.previousSibling;
      if (child.nodeType === 3) {
        if (child.nodeValue.replace(/ /g, ' ').trim() !== '') return;
      } else if (child.nodeType === 1) {
        if (!isBlank(child)) {
          if (depth < 6) trimTail(child, depth + 1);
          return;
        }
        child.style.display = 'none';
      }
      child = prev;
    }
  }

  function tidyDescription() {
    try {
      var roots = document.querySelectorAll('.product-content-below-gallery__description, .product-info__block-item[data-block-type="description"] .prose');
      for (var i = 0; i < roots.length; i++) {
        var items = roots[i].querySelectorAll('li, p');
        for (var j = 0; j < items.length; j++) {
          if (isBlank(items[j])) items[j].style.display = 'none';
          else trimTail(items[j], 5);
        }
        trimTail(roots[i], 0);
      }
    } catch (e) {}
  }

  tidyDescription();

  var cfgEl = document.querySelector('[data-inza-pdp]');
  if (!cfgEl) return;

  var cfg = cfgEl.dataset;
  var isRing = cfg.isRing === 'true';
  var placeholderEnabled = cfg.sizePlaceholderEnabled === 'true';
  var nameLaterEnabled = cfg.nameLaterEnabled === 'true';
  var scope = cfgEl.closest('.shopify-section') || document;

  function findSizeSelect() {
    var selects = scope.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var s = selects[i];
      var name = (s.getAttribute('name') || '').toLocaleLowerCase('tr');
      if (name === 'id' || name.indexOf('quantity') > -1) continue;
      if (name.indexOf('ölçü') > -1 || name.indexOf('olcu') > -1 || name.indexOf('size') > -1) return s;
      for (var j = 0; j < s.options.length; j++) {
        if (/standart/i.test(s.options[j].text)) return s;
      }
    }
    return null;
  }

  function findNameInput() {
    var inputs = scope.querySelectorAll('input[type="text"], input:not([type])');
    for (var i = 0; i < inputs.length; i++) {
      var name = (inputs[i].getAttribute('name') || '').toLocaleLowerCase('tr');
      if (name.indexOf('isim') > -1 || name.indexOf('kolye') > -1) return inputs[i];
    }
    return null;
  }

  function fire(el, type) {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  }

  function clearSizeError(select) {
    select.classList.remove('inza-invalid');
    var errors = scope.querySelectorAll('.inza-field-error');
    for (var i = 0; i < errors.length; i++) errors[i].remove();
  }

  function showSizeError(select) {
    select.classList.add('inza-invalid');
    if (!scope.querySelector('.inza-field-error')) {
      var err = document.createElement('span');
      err.className = 'inza-field-error';
      err.setAttribute('role', 'alert');
      err.textContent = cfg.sizeRequired || '';
      select.insertAdjacentElement('afterend', err);
    }
    try {
      select.scrollIntoView({ block: 'center', behavior: 'smooth' });
      select.focus({ preventScroll: true });
    } catch (e) {}
  }

  function addPlaceholder(select) {
    if (select.querySelector('[data-inza-placeholder]')) return;
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = cfg.sizePlaceholder || '';
    ph.disabled = true;
    ph.hidden = true;
    ph.setAttribute('data-inza-placeholder', '');
    select.insertBefore(ph, select.firstChild);
    ph.selected = true;
    select.selectedIndex = 0;
  }

  function enhanceSize() {
    if (!isRing || !placeholderEnabled) return;
    var select = findSizeSelect();
    if (!select) return;

    // Uygulama seçenek listesini yeniden çizerse ve müşteri henüz seçim yapmadıysa boş duruma geri dön.
    if (select.dataset.inzaInit) {
      if (!select._inzaChosen) addPlaceholder(select);
      return;
    }

    select.dataset.inzaInit = '1';
    addPlaceholder(select);

    select.addEventListener('change', function (event) {
      if (event.isTrusted && select.value !== '') {
        select._inzaChosen = true;
        clearSizeError(select);
      }
    });
  }

  function enhanceName() {
    var input = findNameInput();
    if (!input || input.dataset.inzaInit) return;
    input.dataset.inzaInit = '1';

    var hint = document.createElement('span');
    hint.className = 'inza-field-hint';
    hint.textContent = (cfg.nameHint || '') + ' ';

    if (nameLaterEnabled && cfg.nameLater && cfg.nameLaterValue) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = cfg.nameLater;
      btn.addEventListener('click', function () {
        input.value = cfg.nameLaterValue;
        fire(input, 'input');
        fire(input, 'change');
      });
      hint.appendChild(btn);
    }

    var anchor = input.closest('[class*="input"], [class*="field"]') || input;
    anchor.insertAdjacentElement('afterend', hint);
  }

  // Mağazanın para biçimi düzeltilince bu bölüm kendiliğinden etkisiz kalır.
  var PRICE_RE = /(\d{1,3}(?:,\d{3})+|\d+)\.(\d{2})\s*TL/g;

  function fixPrices() {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency && currency !== 'TRY') return;

    var els = scope.querySelectorAll('sale-price, compare-at-price');
    for (var i = 0; i < els.length; i++) {
      var walker = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        if (text.indexOf('TL') === -1 || text.indexOf('.') === -1) continue;
        var fixed = text.replace(PRICE_RE, function (match, whole, cents) {
          return whole.replace(/,/g, '.') + (cents === '00' ? '' : ',' + cents) + ' TL';
        });
        if (fixed !== text) node.nodeValue = fixed;
      }
    }
  }

  function run() {
    try {
      enhanceSize();
      enhanceName();
      if (document.querySelector('.inza-pay:not([data-inza-watched])')) watchChat();
    } catch (e) {
      if (window.console) console.warn('[inza-cro]', e);
    }
  }

  // Ölçü seçilmeden sepete eklemeyi durdur (uygulamanın kendi kontrolünden bağımsız çalışır).
  document.addEventListener('click', function (event) {
    if (!isRing || !placeholderEnabled) return;
    var btn = event.target.closest && event.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (scope !== document && !scope.contains(btn) && !scope.contains(form)) return;

    var select = findSizeSelect();
    if (select && select.dataset.inzaInit && !select._inzaChosen) {
      addPlaceholder(select);
      event.preventDefault();
      event.stopImmediatePropagation();
      showSizeError(select);
    }
  }, true);

  run();
  try { fixPrices(); } catch (e) {}

  var timer = null;
  var observer = new MutationObserver(function () {
    try { fixPrices(); } catch (e) {}
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 150);
  });
  observer.observe(scope, { childList: true, subtree: true });
})();
